module.exports = __webpack_public_path__ + "img/DE01499.cd669c07.png";